import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import VueScrollTo from 'vue-scrollto';

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueScrollTo, {
    container: 'body',
    duration: 500,
    easing: 'ease',
    offset: -60,
    cancelable: true,
    onDone: false,
    onCancel: false,
    x: false,
    y: true,
});

export {
    Vue,
    Vuex,
    VueRouter,
    VueScrollTo,
};


// WEBPACK FOOTER //
// ./source/framework/core/libs.js